// Consentimento de cookies (LGPD) — persistido no localStorage, compartilhado
// por toda a árvore React (banner + rodapé + futuro gate de analytics).

export const CONSENT_STORAGE_KEY = 'joyn_cookie_consent';

// Disparado pelo link "Preferências de cookies" do rodapé pra reabrir o
// painel de personalização depois que o usuário já decidiu uma vez.
export const CONSENT_REOPEN_EVENT = 'joyn-cookie-prefs-open';

// Disparado quando o usuário decide (aceita/recusa/salva) — o banner fecha
// nessa hora. Usado por outras barras fixas no rodapé (ex.: convite do app)
// pra só aparecerem depois que o banner sai da tela.
export const CONSENT_SAVED_EVENT = 'joyn-cookie-consent-saved';

// Retorna a decisão salva ({ necessary, analytics, timestamp }) ou null se o
// usuário ainda não decidiu (ou o valor salvo está corrompido/no formato
// antigo) — null é o sinal de "banner precisa aparecer".
export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.analytics !== 'boolean') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent(analytics) {
  const consent = {
    necessary: true, // sempre true — não é opcional, não é um cookie de rastreamento
    analytics: Boolean(analytics),
    timestamp: Date.now(),
  };
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
  } catch {
    // localStorage indisponível (aba anônima restrita, storage bloqueado etc.)
    // — a escolha não persiste e o banner volta a aparecer na próxima visita.
  }
  window.dispatchEvent(new Event(CONSENT_SAVED_EVENT));
  return consent;
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event(CONSENT_REOPEN_EVENT));
}
